import { Button } from '@chakra-ui/react';
import { INVITE_TEAM_REDICECT_LINK, UPGRADE_REDIRECT_BIZ_LINK } from 'constants/links';
import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { UserType, UserTypes } from 'modules/User';
import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const DISABLE_INVITE_TEAM_USER_TYPES: UserType[] = [UserTypes.Education];

type InviteTeamButtonProps = {
  userType?: UserType;
  onClick?: () => void;
};

/**
 * Invite team button
 *
 * - Free User & Premium User: Redirect to => '/account/subscription/business'
 * - Education User: N/A
 * - Business Owner & Member: Display Invite them member modal
 * - Enterprise: Redirect to '/infographics/my_team'
 */
export const InviteTeamButton: React.FC<InviteTeamButtonProps> = memo(({ userType, onClick = () => {} }) => {
  const { venngageE2 } = useVenngageE1Gate();
  const { t } = useTranslation('common_navbar');

  const showButton = useMemo(
    () => venngageE2?.experiments?.teamshare === true && userType && !DISABLE_INVITE_TEAM_USER_TYPES.includes(userType),
    [venngageE2, userType],
  );

  // Redirect to subscription page
  const handleRedirect = useCallback(() => {
    if (!userType) return;

    let link;

    switch (userType) {
      case UserTypes.Free:
      case UserTypes.Premium:
        link = UPGRADE_REDIRECT_BIZ_LINK;
        break;
      case UserTypes.Enterprise:
        link = INVITE_TEAM_REDICECT_LINK;
        break;
      case UserTypes.Business:
        break;
      default:
        break;
    }

    // Redirect the current page if link is not empty
    if (link) window.location.href = link;

    // Callback
    onClick();
  }, [userType, onClick]);

  if (!showButton) return null;

  const testId = 'navbar-invite-team-button';
  const label = 'Invite team';

  return (
    <Button variant='upgrade-outline' size='sm' data-testid={testId} aria-label={label} onClick={handleRedirect}>
      {t('navbar.invite-team-button')}
    </Button>
  );
});

InviteTeamButton.displayName = 'InviteTeamButton';
